export const registerSideBar = [
  "Select Membership",
  "Membership Form",
  "Application In Review",
  "Checkout",
  "Status"
];

export const renewSideBar = [
  "Plan Status",
  "Checkout",
  "Thank You"
];
  
export const adminSideBar = [
  "Membership",
  "Membership Form",
  "Application In Review",
];
